var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "navigation-bar" }, [
    _c(
      "div",
      { staticClass: "containerX" },
      [
        _c(
          "router-link",
          {
            staticClass: "logo",
            attrs: { title: "Logo", to: { name: "homePageX" } }
          },
          [
            _c(
              "svg",
              {
                attrs: {
                  width: "124",
                  height: "22",
                  viewBox: "0 0 91 22",
                  fill: "none",
                  xmlns: "http://www.w3.org/2000/svg"
                }
              },
              [
                _c("path", {
                  attrs: {
                    d:
                      "M81.6095 13.8951C81.5945 17.7271 79.0175 20.9221 75.2695 21.7561C70.9235 22.7231 66.4905 19.8771 65.6405 15.4831C64.7125 10.6871 67.8105 6.95809 71.6115 6.05609C73.7375 5.55109 75.7625 5.77409 77.6705 6.88509C77.9225 7.03209 77.9945 7.15609 77.8985 7.46809C77.4505 8.93009 78.1665 10.8491 80.1815 11.0141C80.2695 11.0211 80.3585 11.0321 80.4465 11.0281C81.1475 11.0001 81.1405 11.0011 81.3315 11.7041C81.5265 12.4231 81.6075 13.1531 81.6095 13.8951ZM76.8985 13.8351C76.8895 11.8811 75.3895 10.3171 73.5245 10.3501C71.5815 10.3851 70.1925 11.8911 70.2045 13.9191C70.2165 15.8291 71.7195 17.3671 73.5775 17.3581C75.4515 17.3491 76.9075 15.8041 76.8985 13.8351Z",
                    fill: "white"
                  }
                }),
                _vm._v(" "),
                _c("path", {
                  attrs: {
                    d:
                      "M66.0545 18.9991C63.9255 15.9021 63.9135 11.8551 66.0265 8.76112C66.2325 8.45912 66.1805 8.30011 65.9415 8.07411C64.3835 6.59511 62.5565 5.79212 60.2795 5.80812C60.0065 5.80012 59.6255 5.84212 59.2425 5.88612C57.6685 6.06612 56.2605 6.71612 55.1245 7.67412C55.8335 9.07812 56.2495 10.7821 56.2495 12.6211C56.2495 15.1781 55.4455 17.4771 54.1675 19.0661C55.5365 20.6611 57.5255 21.8161 59.7755 21.9071C62.1955 22.0051 64.2715 21.2761 66.0065 19.5771C66.2175 19.3721 66.2245 19.2471 66.0545 18.9991ZM60.3065 17.3621C58.4595 17.3731 56.9425 15.8001 56.9325 13.8641C56.9235 11.9421 58.4395 10.3521 60.2875 10.3451C62.1445 10.3381 63.6475 11.9041 63.6495 13.8481C63.6525 15.8041 62.1805 17.3511 60.3065 17.3621Z",
                    fill: "white"
                  }
                }),
                _vm._v(" "),
                _c("path", {
                  attrs: {
                    d:
                      "M3.70542 5.17505H7.91042L4.93742 21.233H0.732422L3.70542 5.17505Z",
                    fill: "white"
                  }
                }),
                _vm._v(" "),
                _c("path", {
                  attrs: {
                    d:
                      "M22.9256 16.14C22.9256 19.627 19.9316 21.233 16.1086 21.233H7.93262L10.9056 5.17505H18.4236C21.7786 5.17505 23.5846 6.52805 23.5846 8.93705C23.5846 10.864 22.5436 12.217 20.9296 12.951C22.2036 13.547 22.9256 14.649 22.9256 16.14ZM18.7416 16.048C18.7416 15.084 18.0196 14.694 16.9996 14.694H13.2836L12.6886 17.951H16.3416C17.8076 17.952 18.7416 17.332 18.7416 16.048ZM14.4516 8.45505L13.8786 11.552H16.8946C18.3816 11.552 19.1886 10.91 19.1886 9.71705C19.1886 8.84505 18.5306 8.45505 17.4256 8.45505H14.4516Z",
                    fill: "white"
                  }
                }),
                _vm._v(" "),
                _c("path", {
                  attrs: {
                    d:
                      "M30.7206 8.68407L30.2316 11.3911H36.8366L36.2206 14.7861H29.5947L29.0636 17.7221H36.8576L36.1776 21.2321H24.2646L27.2376 5.17407H38.8756L38.2176 8.68407H30.7206Z",
                    fill: "white"
                  }
                }),
                _vm._v(" "),
                _c("path", {
                  attrs: {
                    d:
                      "M50.0263 12.859H53.7433L52.4903 19.626C50.9613 20.865 48.8803 21.553 46.6293 21.553C42.0843 21.553 39.1533 18.686 39.1533 14.488C39.1533 8.91403 42.9553 4.85303 48.6043 4.85303C51.5773 4.85303 53.7443 5.88503 55.0813 7.81203L52.0653 10.381C51.0883 9.07303 49.9413 8.61503 48.4123 8.61503C45.3543 8.61503 43.4003 10.978 43.4003 14.189C43.4003 16.345 44.7593 17.791 47.2023 17.791C47.8823 17.791 48.5403 17.676 49.1773 17.401L50.0263 12.859Z",
                    fill: "white"
                  }
                }),
                _vm._v(" "),
                _c("path", {
                  attrs: {
                    d:
                      "M4.02345 2.04508C4.01945 0.945079 4.93445 0.0270787 6.03845 0.0230787C7.13045 0.0200787 8.05645 0.931079 8.08045 2.03208C8.10345 3.11908 7.18245 4.06308 6.08645 4.07708C4.92445 4.09008 4.02845 3.20708 4.02345 2.04508Z",
                    fill: "#EEBA2E"
                  }
                }),
                _vm._v(" "),
                _c("path", {
                  attrs: {
                    d:
                      "M76.4673 1.28809C77.3403 1.52709 78.0683 1.96809 78.6973 2.57009C79.8953 3.71509 80.5303 5.10709 80.4893 6.78209C80.4723 7.47109 80.5073 8.15109 80.7773 8.80109C81.3483 10.1761 82.8183 11.0671 84.2813 10.9151C85.8573 10.7521 86.3793 10.5321 87.8363 9.49209C87.6493 9.98809 87.5013 10.5021 87.2693 10.9761C86.2183 13.1241 83.7943 14.3811 81.3823 14.0581C79.0193 13.7411 76.9893 11.8561 76.5463 9.54709C76.4793 9.20009 76.4523 8.84109 76.4503 8.48709C76.4403 6.18609 76.4433 3.88509 76.4433 1.58409C76.4443 1.49809 76.4573 1.41209 76.4673 1.28809Z",
                    fill: "#101C2B"
                  }
                }),
                _vm._v(" "),
                _c("path", {
                  attrs: {
                    d:
                      "M77.1012 2.00513C77.8762 2.21713 78.5232 2.60913 79.0822 3.14413C80.1462 4.16113 80.7102 5.39713 80.6742 6.88513C80.6592 7.49713 80.6902 8.10113 80.9302 8.67813C81.4372 9.89913 82.7432 10.6901 84.0422 10.5561C85.4422 10.4111 85.9052 10.2161 87.2002 9.29213C87.0342 9.73213 86.9022 10.1891 86.6972 10.6101C85.7642 12.5171 83.6112 13.6351 81.4692 13.3481C79.3702 13.0671 77.5672 11.3921 77.1742 9.34113C77.1152 9.03313 77.0902 8.71413 77.0892 8.40013C77.0812 6.35613 77.0832 4.31313 77.0832 2.26913C77.0812 2.19213 77.0922 2.11513 77.1012 2.00513Z",
                    fill: "#EEBA2E"
                  }
                }),
                _vm._v(" "),
                _c("path", {
                  attrs: {
                    d:
                      "M82.1975 8.81506C81.9765 6.90106 82.3865 5.17106 83.6655 3.69106C84.9585 2.19706 86.6045 1.45806 88.5745 1.43106C89.0595 1.42406 89.5455 1.41606 90.0305 1.42706C90.1135 1.42906 90.2665 1.52406 90.2645 1.57206C90.2405 2.21106 90.2805 2.86906 90.1355 3.48206C89.9245 4.38206 88.9805 4.99206 88.0575 5.03606C85.4665 5.16106 83.5405 6.35506 82.3315 8.66906C82.3065 8.71806 82.2745 8.76306 82.2435 8.80906C82.2405 8.81506 82.2245 8.81206 82.1975 8.81506Z",
                    fill: "#EEBA2E"
                  }
                })
              ]
            )
          ]
        ),
        _vm._v(" "),
        _c("div", { staticClass: "content_mc_wrp" }, [
          _c("div", { staticClass: "container-fluid" }, [
            _c(
              "div",
              { staticClass: "header__nav" },
              [
                _vm.crumbs.length > 0
                  ? _c("RouteMap", { attrs: { mapRoutes: _vm.crumbs } })
                  : _vm._e()
              ],
              1
            )
          ])
        ])
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-520eda5c", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-520eda5c","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/global/MainHeader.vue
// module id = null
// module chunks = 